import { render } from "./TrendsOverview.vue?vue&type=template&id=2d2f4dc2&scoped=true"
import script from "./TrendsOverview.vue?vue&type=script&lang=js"
export * from "./TrendsOverview.vue?vue&type=script&lang=js"

import "./TrendsOverview.vue?vue&type=style&index=0&id=2d2f4dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2f4dc2"]])

export default __exports__